<!--
 * @Description: 机构青睐赛道
 * @Author:  单珊珊
 * @Date: 2022-02-16 09:37:21
 * @LastEditTime: 2022-07-06 15:32:53
 * @LastEditors:  
-->
<template>
<div class="company-filter">
  <div class="org-track common-container">
    <div class="org-likes">
      <div class="header">
        <div class="left title-underline">机构青睐赛道</div>
        <!-- <div class="right orange more">查看更多</div> -->
      </div>
      <div class="org-likes-container">
        <div class="org-likes-item-wider" v-for="item,index in org_track_list" :key="index">
          <div class="header">
            <!-- <p class="common-title-p orange" @click="goToTrackDetail(item.id)">{{item.name}}</p> -->
            <div class="title">
              <p class="common-title-p orange" @click="goToTrackDetail(item.id)">{{item.name}}</p>
              <div @click="goToTrackDetail(item.id)">赛道详情</div>
            </div>
            <div class="event">
              <span class="name">投融资事件：<span class="number orange">{{item.eventCount}}</span>笔</span>
              <span class="name">IPO：<span class="number orange">{{item.ipoCount}}</span>笔</span>
            </div>
          </div>
          <div class="content-wrap">
            <div class="item-wrap">
              <p>代表项目</p>
              <div class="item" v-for="comp,index1 in item.comp" :key="index1">
                <div class="image">
                  <img :src="img_req_url + comp.logoPath"/>
                </div>
                <div class="info">
                  <div class="org-name l1-ellipsis" @click="toEntity(comp.type, comp.uid)">{{comp.shortName}}<span class="round">{{comp.roundName}}</span></div>
                  <div class="org-desc l1-ellipsis">{{comp.description}}</div>
                </div>
              </div>
            </div>
            <div class="item-wrap">
              <p>代表机构</p>
              <div class="item" v-for="org,index2 in item.org" :key="index2">
                <div class="image">
                  <img :src="img_req_url + org.logoPath"/>
                </div>
                <div class="info">
                  <div class="org-name l1-ellipsis" @click="toEntity(org.type, org.uid)">{{org.shortName}}</div>
                  <div class="org-desc l1-ellipsis">{{org.description}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spin v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
    <div class="right-wrap">
      <rcTrack></rcTrack>
      <activeTrack class="item"></activeTrack>
      <activeAgency class="item"></activeAgency>
      <prospectus class="item"></prospectus>
    </div>
  </div>
</div>
</template>

<script>
import { getOrgLikeTrack } from '@/service.js'
import prospectus from './components/Prospectus'
import activeAgency from '@/components/vcbeat/ActiveAgency.vue'
import activeTrack from '@/components/vcbeat/Activetrack.vue'
import rcTrack from '@/components/vcbeat/RCtrack.vue'
import filter from 'js/filter'
export default {
  components: { prospectus, activeAgency, activeTrack, rcTrack },
  data() {
    return {
      org_track_list: [],
      loading: true
    }
  },
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    },
  },
  beforeMount() {
    this.getOrgLikeTrack()
  },
  methods: {
    //机构青睐列表
    async getOrgLikeTrack() {
      let res = await getOrgLikeTrack({ size: 12 }, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.code == 0) {
        this.round_list = this.$store.state.round
        this.org_track_list = res.data
        this.org_track_list.map(item => {
          item.comp.map(comp => {
            this.$set(comp, 'roundName', filter.dealNeed(comp.roundId, this.round_list))
          })
        })
        this.loading = false
      }
    },
    //跳转至公司或机构详情
    toEntity(type, id) {
      if(type == 0){
        const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: id } })
        window.open(href, '_blank')
      }else if(type == 1){
        const { href } = this.$router.resolve({ name: 'OrgDetail', params: { uid: id } })
        window.open(href, '_blank')
      }
    },
    //跳转至赛道详情
    goToTrackDetail(id) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { tag: id } })
      window.open(href, '_blank')
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_track.stylus'
@import '~styles/common_vcbeat.stylus'
.company-filter
  background #fff
  display flex
  justify-content center
.common-container
  width 1200px
  margin 20px auto 
  .org-likes
    width 866px
    margin-right 30px
    .org-likes-container
      margin-top: 20px
  .right-wrap
    width 304px
    .item
      margin-top 30px
  >>>.ivu-spin
    margin-top 20px
    color #FA5A00
</style>
